import { v4 as uuid } from 'uuid';

import { definitions, operations } from '@luxuryescapes/contract-svc-promo';

import { PromoCondition } from '~/services/PromoService';

type PromoConditionPayload =
  operations['createOrUpdatePromoCodeCondition']['requestBody']['content']['application/json']['promoCodeCondition'];

export type PendingCopiedPromoCondition = PromoCondition & {
  isPendingCopy: true;
};

export function copyPromoCondition(
  condition: PromoCondition,
  conditionTypes: Array<{ key: string }>,
  newId = uuid(),
): PendingCopiedPromoCondition {
  return {
    id: newId,
    id_promo_code: condition.id_promo_code,
    condition_type: condition.condition_type,
    condition_value: condition.condition_value,
    condition_apply_type: condition.condition_apply_type,
    promo_code_discount_ids: [...(condition.promo_code_discount_ids ?? [])],
    customized_message: condition.customized_message ?? '',
    isNew: true,
    isPendingCopy: true,
    config: condition.config ?? conditionTypes.find((conditionType) => conditionType.key === condition.condition_type),
  } as PendingCopiedPromoCondition;
}

export function pendingPromoConditionToCreatePayload(
  condition: PendingCopiedPromoCondition,
  promoCodeId: string,
): PromoConditionPayload {
  return {
    condition_type: condition.condition_type,
    condition_value: typeof condition.condition_value === 'string' ? condition.condition_value : '',
    condition_apply_type:
      condition.condition_apply_type as definitions['PromoCodeConditionPresented']['condition_apply_type'],
    id_promo_code: promoCodeId,
    customized_message: condition.customized_message === '' ? undefined : (condition.customized_message ?? undefined),
    promo_code_discount_ids: condition.promo_code_discount_ids ?? [],
  };
}
